import { configureApiEntity } from '../adapter/index';

import { schema } from 'normalizr';

export const resourceSchema = new schema.Entity('resources');

export const resources = configureApiEntity('RESOURCES', 'resources', resourceSchema);
